import React, { useState, useEffect } from "react";

import { FaCheck, FaDotCircle } from "react-icons/fa";

import { Calender } from "../../components/Calender/Calender";
import apiClient, { initializeApiClient } from "../../api/apiClient";

import moment from "moment";
import { toast } from "react-toastify";

function formatDate(date, format = "YYYY-MM-DD") {
  return moment(date).format(format);
}

export default () => {
  const [keyss, setKeyss] = useState([]);

  const [event, setevents] = useState([]);

  const [vehiclesid, setvehiclesid] = useState();

  const [todayEvents, setTodayEvents] = useState([]);

  const [selectedEvent, setSelectedEvent] = useState(null);

  const fetchevent = async () => {
    initializeApiClient();
    const res = await apiClient.get("/schedule/events/");
    console.log("events", res.data);
    if (res.status === 200) {
      setevents(res.data);  

      const today = moment().format("YYYY-MM-DD");
      const filteredEvents = res.data.filter((event) => event.date === today);
      setTodayEvents(filteredEvents);
    }
  };

  const fetchRequest = async () => {
    initializeApiClient();
    const res = await apiClient.get("/schedule/event-types/");
    if (res.status === 200) {
      setKeyss(res.data);
    }
  };

  useEffect(() => {
    fetchRequest();
  }, []);

  useEffect(() => {
    fetchevent();
  }, []);

  const onEventSubmit = async (data) => {
    try {
      const formdata = { ...data };
      formdata.date = formatDate(formdata.date);

      const result = await apiClient.post("/schedule/events/", formdata);

      if (result) {
        toast.success("Event added successfully");
      } else {
        toast.error("Error adding event");
      }
    } catch (error) {
      console.error("Error submitting event:", error);
      toast.error("Error adding event");
    }
  };

  function eventIcon(icon) {
    switch (icon) {
      case "Photoshoot":
        return (
          <img
            width="100%"
            src={require("../../assets/img/camera-icon.png")}
            alt=""
          />
        );
        break;
      case "campaigns start":
        return <FaDotCircle color="#00D030" />;
        break;
      case "campaigns End":
        return <FaDotCircle color="#F20000" />;
        break;
      case "Special Event":
        return (
          <i
            className="bi bi-balloon-heart-fill"
            style={{
              color: "black",
              fontSize: "22px",
              display: "flex",
              alignItems: "center",
            }}
          ></i>
        );
        break;
      case "Swarm":
        return (
          <img width="100%" src={require("../../assets/img/bee.png")} alt="" />
        );
        break;
      case "Repair":
        return (
          <img
            width="100%"
            src={require("../../assets/img/retargeting.png")}
            alt=""
          />
        );
        break;
      case "Removal":
        return (
          <img
            width="100%"
            src={require("../../assets/img/schedule-x-icon.PNG")}
            alt=""
          />
        );
        break;
      case "Install":
        return (
          <img
            width="100%"
            src={require("../../assets/img/schedule-job-icon.png")}
            alt=""
          />
        );
        break;
      default:
        break;
    }
  }
  const [submitData, setSubmitData] = useState();
  const [data, setData] = useState();
  const [vehicles, setVehicles] = useState([]);

  const handleChange = (key, value) => {
    setSubmitData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };
  const fetch = async () => {
    const response = await apiClient.get("/vehicles/vehicle/");
    if (response.status === 200) {
      setVehicles(response.data);
    }
  };
  useEffect(() => {
    fetch();
  }, []);

  const handleEventsChange = async (events) => {
    const eventObjects = events.map((event) => ({
      color: event.color,
      date_time: event.date,
      title: event.title,
    }));
    setSubmitData({
      ...submitData,
      events: eventObjects,
    });
  };
  const currentDate = new Date();
  const options = {
    weekday: "long",
    month: "long",
    day: "numeric",
    suffix: "long",
  };
  const formattedDate = currentDate.toLocaleDateString("en-US", options);

  const displayDate = data?.date || formattedDate;

  function handleDateClick(date, events) {
    setData({ date, events });
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitData) {
      onEventSubmit(submitData);
    } else {
      toast.error("Please fill in all required fields");
    }
  };

  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const handleVehicleSelect = (vehicle) => {
    setSelectedVehicle(vehicle);
    setvehiclesid({ vehicle_id: vehicle.id });
    handleChange("vehicle_id", vehicle.id);
  };

  const handleEventClick = (clickedEvent) => {
    setSelectedEvent(clickedEvent);
  };

  return (
    <div>
      <form>
        <div className="">
          <div className="dropdown mb-2 ">
            <button
              className="btn btn_bg shadow-none dropdown-toggle w-25"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {selectedVehicle
                ? selectedVehicle.vehicle_model
                : "Select Vehicle"}
            </button>
            <ul
              className="dropdown-menu "
              style={{ color: "#005E9D" }}
              aria-labelledby="dropdownMenuButton1"
            >
              {vehicles.length > 0
                ? vehicles.map((vehicle, index) => {
                    return (
                      <div
                        style={{ cursor: "pointer" }}
                        className=""
                        key={index}
                      >
                        <li
                          className="px-2 py-2 "
                          style={{ display: "flex", alignItems: "center" }}
                          onClick={() => handleVehicleSelect(vehicle)}
                        >
                          <div style={{ width: "4rem" }}>
                            <img
                              style={{ width: "100%" }}
                              src={vehicle.frontside_image}
                              alt=""
                            />
                          </div>
                          <a
                            className="dropdown-item t fw-bold"
                            style={{ color: "#005E9D" }}
                          >
                            {vehicle.vehicle_model}
                          </a>
                        </li>
                      </div>
                    );
                  })
                : "Add vehicles first"}
            </ul>
          </div>
        </div>

        {selectedVehicle && (
          <div className="mb-3">
            <h5 className="text_color">Selected Vehicle:</h5>
            <div className="d-flex align-items-center">
              <div style={{ width: "4rem", marginRight: "1rem" }}>
                <img
                  style={{ width: "100%" }}
                  src={selectedVehicle.frontside_image}
                  alt={selectedVehicle.vehicle_model}
                />
              </div>
              <span className="fw-bold">{selectedVehicle.vehicle_model}</span>
            </div>
          </div>
        )}

        <div className="zoom">
          <Calender
            fetchevent={fetchevent}
            save={event}
            onEventSubmit={onEventSubmit}
            keyss={keyss}
            handleDateClick={handleDateClick}
            eventRecords={event}
            vehiclesid={vehiclesid}
            onEventClick={handleEventClick}
          />
        </div>
        <div className="row mt-2">
          <div className="col-md-8">
            <div className="border h-100 me-2 p-2 rounded-3">
              <h5 className="text_color">
                {selectedEvent
                  ? moment(selectedEvent.date).format("dddd, MMMM D")
                  : moment().format("dddd, MMMM D")}
              </h5>
              <hr className="hr_design mt-0" />
              {selectedEvent ? (
                <div className="d-flex gap-2 align-item-center flex-column flex-md-row">
                  <div style={{ width: "1rem", height: "1rem" }}>
                    <img
                      src={selectedEvent?.event_type?.icon_url}
                      width={"100%"}
                      height={"100%"}
                      alt=""
                    />
                  </div>
                  <span>
                    - {selectedEvent.event_type.request_type} at{" "}
                    {new Date(
                      `${selectedEvent.date}T${selectedEvent.time}`
                    ).toLocaleString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                      hour: "numeric",
                      minute: "numeric",
                      hour12: true,
                    })}
                    <br />- Address: {selectedEvent.address || "N/A"}
                  </span>
                </div>
              ) : (
                <>
                  {todayEvents.length > 0
                    ? todayEvents.map((event, index) => (
                        <div
                          key={event.id || `event-${index}`}
                          className="d-flex gap-2 align-item-center flex-column flex-md-row"
                        >
                          <div style={{ width: "1rem", height: "1rem" }}>
                            <img
                              src={event?.event_type?.icon_url}
                              width={"100%"}
                              height={"100%"}
                              alt=""
                            />
                          </div>
                          <span>
                            - {event.event_type.request_type} at{" "}
                            {new Date(
                              `${event.date}T${event.time}`
                            ).toLocaleString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              hour: "numeric",
                              minute: "numeric",
                              hour12: true,
                            })}
                            <br />- Address: {event.address || "N/A"}
                          </span>
                        </div>
                      ))
                    : "No events scheduled for today"}
                </>
              )}
            </div>
          </div>
          <div className="col-md-4 border p-2 rounded-3">
            <div className="d-flex gap-3 align-item-center px-2">
              <div>
                <h5 className="text_color">Key</h5>
                <hr className="hr_design_2 mt-0" />
              </div>
              <div className="mt-3 ">
                {keyss.map((event, index) => {
                  return (
                    <p
                      key={event.id || `key-${index}`}
                      className=" text_color d-flex align-items-center gap-1"
                    >
                      <div style={{ width: "1rem" }}>
                        <img width="100%" src={event.icon_url} alt="" />
                      </div>
                      {event.request_type}
                    </p>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {/* <div className="col text-center mt-5 save-main">
            <button
              onClick={() => handleSubmit()}
              className="btn_bgnone btn blue-clr"
            >
              <span className="pe-2">Save Changes</span>
              <FaCheck />
            </button>
          </div> */}
        </div>
      </form>
    </div>
  );
};
